import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChildren, QueryList, SimpleChanges, OnChanges } from "@angular/core"
import { IconImageService } from "@shared/services/icon-image.service"
import { ImageFilterService } from "@shared/services/image-filter.service"

@Component({
  selector: "ag-toggle-button",
  templateUrl: "./ag-toggle-button.component.html",
  styleUrls: ["./ag-toggle-button.component.scss"],
  standalone: false,
})
export class AgToggleButtonComponent implements OnInit, OnChanges {
  @Input() option1: string = "Option 1"
  @Input() option2: string = "Option 2"
  @Input() option3: string = "Option 3"
  @Input() option4: string = "Option 4"
  @Input() option1WithImage: string[] = ["Option 1", this.iconImageService.Icon.check]
  @Input() option2WithImage: string[] = ["Option 2", this.iconImageService.Icon.check]
  @Input() option3WithImage: string[] = ["Option 3", this.iconImageService.Icon.check]
  @Input() option4WithImage: string[] = ["Option 4", this.iconImageService.Icon.check]
  // If you want the options to have less than 120px per option, if the text doesnt fit, it automatically changes the width
  @Input() widthPerOption: number = 120
  @Input() numberOfOptions: number = 2
  @Input() initValue: string = ""
  @Input() disabled: boolean = false
  @Input() notSelectedDisable: boolean = false
  @Input() imageOption: boolean = false
  @Input() blackImages: boolean = true
  @Input() imageAndText: boolean = false
  @Input() mobileVersion: boolean = false
  @Input() initEmit: boolean = true
  @Input() hint: string[] = []
  @Input() size: "medium" | "large" = "medium"

  @Output() public chosenOption = new EventEmitter<string>()

  @ViewChildren("optionText") optionTexts: QueryList<ElementRef>

  selectedOption: string
  disableField: boolean = false

  constructor(public iconImageService: IconImageService, public imageFilter: ImageFilterService) {}

  ngOnInit(): void {
    if (this.numberOfOptions > 4) this.numberOfOptions = 4
    const val = this.initValue.toLowerCase()
    const match = (opt: string) => opt.toLowerCase() === val
    if (this.initEmit) {
      if (this.initValue.length !== 0) {
        if (match(this.option1)) this.outsideSelect("1")
        else if (match(this.option2)) this.outsideSelect("2")
        else if (match(this.option3)) this.outsideSelect("3")
        else if (match(this.option4)) this.outsideSelect("4")
      } else this.outsideSelect("1")
      this.disableField = this.disabled
    } else {
      if (this.initValue.length !== 0) {
        if (match(this.option1)) this.selectedOption = "1"
        else if (match(this.option2)) this.selectedOption = "2"
        else if (match(this.option3)) this.selectedOption = "3"
        else if (match(this.option4)) this.selectedOption = "4"
      }
    }
    if (this.widthPerOption === 120) this.updateWidthPerOption()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["initValue"] && !changes["initValue"].isFirstChange()) {
      this.initValue = changes["initValue"].currentValue
      if (this.initValue.length !== 0) {
        if (this.initValue === this.option1) this.outsideSelect("1")
        else if (this.initValue === this.option2) this.outsideSelect("2")
        else if (this.initValue === this.option3) this.outsideSelect("3")
        else if (this.initValue === this.option4) this.outsideSelect("4")
      } else this.outsideSelect("1")
    }
  }

  outsideSelect(option: string) {
    if (!this.disableField) {
      this.selectedOption = option

      if (this.selectedOption === "1") this.chosenOption.emit(this.option1)
      else if (this.selectedOption === "2") this.chosenOption.emit(this.option2)
      else if (this.selectedOption === "3") this.chosenOption.emit(this.option3)
      else if (this.selectedOption === "4") this.chosenOption.emit(this.option4)
    }
  }

  select(option: string) {
    if (this.notSelectedDisable) return
    if (!this.disableField) {
      this.selectedOption = option
      if (this.imageAndText) {
        if (this.selectedOption === "1") this.chosenOption.emit(this.option1WithImage[0])
        else if (this.selectedOption === "2") this.chosenOption.emit(this.option2WithImage[0])
        else if (this.selectedOption === "3") this.chosenOption.emit(this.option3WithImage[0])
        else if (this.selectedOption === "4") this.chosenOption.emit(this.option4WithImage[0])
      } else {
        if (this.selectedOption === "1") this.chosenOption.emit(this.option1)
        else if (this.selectedOption === "2") this.chosenOption.emit(this.option2)
        else if (this.selectedOption === "3") this.chosenOption.emit(this.option3)
        else if (this.selectedOption === "4") this.chosenOption.emit(this.option4)
      }
    }
  }

  getSliderWidth(): string {
    return `${this.widthPerOption}px`
  }

  getContainerWidth(): string {
    const totalWidth = this.numberOfOptions * this.widthPerOption + this.numberOfOptions * 4 + 4
    return `${totalWidth}px`
  }

  getTransform(): string {
    const optionIndex = parseInt(this.selectedOption, 10) - 1
    if (optionIndex !== 0) return `translateX(${optionIndex * (this.widthPerOption + 4) + 4}px)`
    else return `translateX(${4}px)`
  }

  updateWidthPerOption(): void {
    const options = [this.option1, this.option2, this.option3, this.option4].slice(0, this.numberOfOptions)

    let maxWidth = this.widthPerOption

    options.forEach((option) => {
      const textWidth = this.getTextWidth(option)
      if (textWidth > maxWidth && !this.imageOption) {
        maxWidth = textWidth
      }
    })

    this.widthPerOption = maxWidth

    if (this.imageOption) {
      this.widthPerOption = 60
    }
  }

  getTextWidth(text: string): number {
    const canvas = document.createElement("canvas")
    const context = canvas.getContext("2d")
    if (context) {
      context.font = "14px Poppins-Regular"
      const metrics = context.measureText(text)
      return metrics.width + 20
    }
    return 120
  }
}
